export * from './LocationResultCardContentV2';
